import { render } from "./index.vue?vue&type=template&id=6a3e7bb6&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./style/index.scss?vue&type=style&index=0&id=6a3e7bb6&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=6a3e7bb6&scoped=true&lang=css"

import exportComponent from "D:\\chat-tx\\chat-example\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a3e7bb6"]])

export default __exports__